var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.filtersLoad)?_c('router-view'):_c('div',{staticClass:"main-preloader widget-preloader chart-preloader"},[_c('Loader',{ref:"preloader",attrs:{"animationData":require('@/assets/images/Loader.json'),"autoPlay":true,"loop":true,"speed":1}})],1),_c('UpdatePopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }